export default "__VITE_ASSET__CH73rynn__"